document.addEventListener('DOMContentLoaded', function () {
  // Helper: Get cookie by name
  function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
  }

  // Helper: Set cookie with expiry
  function setCookie(name, value, days) {
    let expires = "";
    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = `${name}=${value || ""}${expires}; path=/; SameSite=Lax; Secure`;
  }

  // Helper: Get URL param by name
  function getURLParameter(name) {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(name);
  }

  // ✅ Only track utm_source and admitad_uid
  const trackingParams = ['utm_source', 'admitad_uid'];

  // Set cookies for those found in URL
  trackingParams.forEach(param => {
    const value = getURLParameter(param);
    if (value) {
      // Validate and sanitize the value
      const sanitizedValue = value.replace(/[<>'"&]/g, '').substring(0, 100);
      if (sanitizedValue && /^[a-zA-Z0-9_-]+$/.test(sanitizedValue)) {
        setCookie(param, sanitizedValue, 30); // Cookie lasts 30 days
      }
    }
  });

  // Read cookies and build cart attributes
  const cartAttributes = {};

  trackingParams.forEach(param => {
    const value = getCookie(param);
    if (value) {
      // Rename admitad_uid → uid, keep others as-is
      if (param === 'admitad_uid') {
        cartAttributes['uid'] = value;
      } else {
        cartAttributes[param] = value;
      }
    }
  });

  // If any attributes exist, send to Shopify
  if (Object.keys(cartAttributes).length > 0) {
    setTimeout(()=> {
      // Check if required global variables are available
    if (!window.routes || !window.routes.cart_update_url) {
      console.error('UTM tracking: Required window.routes not available');
      return;
    }

    // Prevent duplicate requests
    if (window.utmTrackingSent) {
      return;
    }
    window.utmTrackingSent = true;

    const formData = {
      attributes: cartAttributes
    };

    fetch(window.routes.cart_update_url + '.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(res => {
      if (!res.ok) throw new Error('Network response was not ok ' + res.statusText);
      return res.json();
    })
    .then(data => {
      console.log('Cart updated with attributes:', data);
    })
    .catch(error => {
      console.error('Error updating cart:', error);
    });

    },1000)
    
  }
});
